module.exports = __webpack_public_path__ + "media/images/riders/small/VALENTINA_HOLL-c6afb747f7ad75d87c4e7eecb8a4a5f0.png";